import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../contexts/BookingContext';
import ProgressBar from '../components/ProgressBar';
import { transportOptions } from '../data/mockData';

const TransportPage: React.FC = () => {
  const navigate = useNavigate();
  const { setTransport } = useBooking();
  const [selectedOption, setSelectedOption] = useState<any>(null);

  const handleOptionSelect = (option: any) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      setTransport(selectedOption);
      navigate('/stay-booking');
    }
  };

  const handleSkip = () => {
    navigate('/stay-booking');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        <ProgressBar currentStep={2} />
        
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            你想怎麼抵達花蓮？
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            選擇最適合您的交通方式，我們將為您安排完整的接駁服務
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {transportOptions.map((option) => (
            <div
              key={option.id}
              onClick={() => handleOptionSelect(option)}
              className={`bg-white rounded-2xl shadow-soft p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-medium ${
                selectedOption?.id === option.id
                  ? 'ring-4 ring-blue-200 bg-blue-50'
                  : 'hover:bg-gray-50'
              }`}
            >
              <div className="text-4xl mb-4">{option.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {option.title}
              </h3>
              <p className="text-gray-600 mb-4">{option.description}</p>
              
              <div className="space-y-2 mb-4">
                <div className="flex items-center text-sm text-gray-500">
                  <span className="mr-2">⏱️</span>
                  {option.duration}
                </div>
                <div className="flex items-center text-sm text-gray-500">
                  <span className="mr-2">💰</span>
                  {option.price}
                </div>
              </div>

              <div className="flex flex-wrap gap-1">
                {option.features.map((feature, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full"
                  >
                    {feature}
                  </span>
                ))}
              </div>

              {selectedOption?.id === option.id && (
                <div className="mt-4 text-center">
                  <div className="inline-flex items-center text-blue-600 font-semibold">
                    <span className="mr-2">✓</span>
                    已選擇
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {selectedOption && (
            <button
              onClick={handleNext}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold py-3 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-medium"
            >
              下一步
            </button>
          )}
          
          <button
            onClick={handleSkip}
            className="w-full sm:w-auto bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-8 rounded-2xl transition-all duration-300"
          >
            我不需要此服務
          </button>
        </div>

        {selectedOption && (
          <div className="mt-8 bg-blue-50 rounded-2xl p-6 max-w-2xl mx-auto">
            <h3 className="text-lg font-semibold text-blue-800 mb-2">
              已選擇：{selectedOption.title}
            </h3>
            <p className="text-blue-600">
              我們將為您安排 {selectedOption.duration} 的交通服務，
              費用為 {selectedOption.price}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransportPage; 